import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  addHealthCheckupTestInclusion,
  fetchHealthCheckupTestInclusions,
} from "../../Adapters/ApiAdapter";

const AddHealthCheckupTestInclusion = () => {
  const [formData, setFormData] = useState({
    inclusion_name: "",
    test_id: "",
  });
  const [loading, setLoading] = useState(false);
  const [tests, setTests] = useState([]);

  // Fetch test options on mount
  useEffect(() => {
    const fetchTests = async () => {
      try {
        const response = await fetchHealthCheckupTestInclusions();
        if (response?.status === "true") {
          // Extract unique test_id + test_name pairs
          const uniqueTests = Array.from(
            new Map(
              response.data.map((item) => [
                item.test_id,
                { id: item.test_id, name: item.test_name },
              ])
            ).values()
          );
          setTests(uniqueTests);
        } else {
          toast.error("Failed to load test list.");
        }
      } catch (error) {
        toast.error("Error loading test list.");
      }
    };

    fetchTests();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await addHealthCheckupTestInclusion(formData);
      if (response?.message) {
        toast.success("Test Inclusion added successfully!");
        setFormData({
          inclusion_name: "",
          test_id: "",
        });
      } else {
        toast.error("Failed to add Test Inclusion.");
      }
    } catch (error) {
      toast.error("An error occurred while adding the Test Inclusion.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box m="20px">
      <ToastContainer />
      <Typography variant="h4" gutterBottom>
        Add Health Checkup Test Inclusion
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Inclusion Name"
          name="inclusion_name"
          value={formData.inclusion_name}
          onChange={handleInputChange}
          required
        />

        <FormControl fullWidth margin="normal" required>
          <InputLabel id="test-id-label">Select Test</InputLabel>
          <Select
            labelId="test-id-label"
            name="test_id"
            value={formData.test_id}
            onChange={handleInputChange}
            label="Select Test"
          >
            {tests.map((test) => (
              <MenuItem key={test.id} value={test.id}>
                {test.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={loading}
          style={{ marginTop: "20px" }}
        >
          {loading ? <CircularProgress size={24} /> : "Add Test Inclusion"}
        </Button>
      </form>
    </Box>
  );
};

export default AddHealthCheckupTestInclusion;
